module.exports = __webpack_public_path__ + "static/img/demo_1_and.a6bdf466.png";